import { useQuery } from '@apollo/client';
import {
  MostRequestHistoryListDocument,
  MostRequestHistoryListFilterInput,
  MostRequestHistoryListQuery,
} from 'src/graphql/generated/graphql';

const PAGINATION_LIMIT = 20;

interface UseMostHistoryProps {
  filter: MostRequestHistoryListFilterInput;
  sorting?: MostRequestHistoryListFilterInput;
  pagination?: {
    limit: number;
    page: number;
    extraRows?: number;
  };
  onCompleted?: (data: MostRequestHistoryListQuery) => void;
  skip?: boolean;
}

export const useMostHistory = (props?: UseMostHistoryProps) => {
  const { filter = {}, sorting, pagination, skip, onCompleted } = props || {};
  const {
    limit = PAGINATION_LIMIT,
    page = 0,
    extraRows = 0,
  } = pagination || {};
  const offset = page * limit;

  const { data, loading } = useQuery<MostRequestHistoryListQuery>(
    MostRequestHistoryListDocument,
    {
      variables: {
        filter,
        sorting,
        pagination: { limit: limit + extraRows, offset },
      },
      skip,
      onCompleted,
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-only',
    },
  );

  return { records: data?.mostRequestHistoryList?.records || [], loading };
};
